import { Modal } from 'antd';
import { useState } from 'react';

import ImagesSlider from 'components/imagesSlider';

import { dataLayerHandleEvent } from 'utils/dataLayers';

import styles from './style.module.css';

export function ModalZoomImg({ handleCloseZoom, images, initIndex }) {
  const [imageIndex, setImageIndex] = useState(initIndex);

  // podemos deducir que el modal esta abierto si initIndex es distinto de null y nos evitamos una prop y useState en el padre.
  const modalVisible = initIndex !== null;

  const handleUpdateIndex = (index) => {
    // cuando llega aqui, el index es el index de la imagen que se va a mostrar y el imageIndex es el index de la imagen que se esta mostrando. Queda por determinar si el event_detail_2 es correcto pero es lo de menos. Si no se han quejado hasta ahora...
    // lo que no estamos haciendo bien es calcular el next y back porque si estas en la ultima slide y haces next, estamos poniendo back porque index < imageIndex. Hay que controloar que pasa cuando haces next en la ultima slide y cuando haces prev en la primera slide
    let buttonClick = index > imageIndex ? 'next' : 'back';
    // ultima slide y haces next
    if (index === 0 && imageIndex === images.length - 1) {
      buttonClick = 'next';
    }
    // primera slide y haces prev
    if (index === images.length - 1 && imageIndex === 0) {
      buttonClick = 'back';
    }

    dataLayerHandleEvent({
      event: 'item_photos',
      event_category: 'product detail',
      event_detail_1: buttonClick,
      event_detail_2: images[imageIndex]?.md,
    });
    setImageIndex(index);
  };

  const handleClose = () => {
    dataLayerHandleEvent({
      event: 'item_photos',
      event_category: 'product detail',
      event_detail_1: 'close',
      event_detail_2: images[imageIndex]?.md ?? '',
    });
    setImageIndex(null);
    handleCloseZoom();
  };

  return (
    <Modal
      className={styles.fullModal}
      width={'100%'}
      title={null}
      visible={modalVisible}
      closable={false}
      destroyOnClose={true}
      onCancel={handleClose}
      footer={null}
      style={{
        height: '100%',
      }}
      wrapClassName={styles.wrapModal}
    >
      <button onClick={handleCloseZoom} className={`${styles.zoomImgClose} ${styles.zoomImgSpan}`}>
        ✕
      </button>
      <div id="fullscreenContainer">
        <ImagesSlider setImageIndex={handleUpdateIndex} images={images} initIndex={initIndex} />
      </div>
    </Modal>
  );
}
